import { gql } from '@apollo/client'
import { useState, useEffect } from 'react'
import { Alert, Input } from 'reactstrap'
import { MONTH_END_LIST_QUERY } from '../../../graphql'
import { handleGraphQLErrors } from '../../../utils'
import Spinner from '../../Spinner/Spinner'

export const MONTH_END_LIST = gql(MONTH_END_LIST_QUERY)

export default function MonthInput({ handleChange, name, end, defaultValue }) {
  console.log('MonthInput rendered')

  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  let checkedDefaultValue
  if (items) {
    if (end) {
      checkedDefaultValue = items[items.length-1].props.value
    } else {
      checkedDefaultValue = items[items.length-2].props.value
    }
  }

  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: MONTH_END_LIST, fetchPolicy: 'cache-first' })
        if (data.monthEndList) {
          const menuItems = []
          for (let item of data.monthEndList) {
            menuItems.push(<option key={item.id} value={item.id}>{item.name}</option>)
          }
          setItems(menuItems)
          if (end) {
            handleChange({ target: { name: name, value: menuItems[menuItems.length-1].props.value } })
          } else {
            handleChange({ target: { name: name, value: menuItems[menuItems.length-2].props.value } })
          }
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  }, [end, handleChange, items, name])

  if (graphQLErrors.length > 0) {
    return <Alert color='danger'>{graphQLErrors[0].message}</Alert>
  } else if (items) {
    defaultValue = defaultValue ? defaultValue : checkedDefaultValue
    return (
      <Input style={{ display: 'inline-block', width: 'auto' }} type="select" defaultValue={defaultValue} name={name} onChange={handleChange}>
        {items}
      </Input>
    )
  } else {
    return <Spinner />
  }
}
